import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=038178c2&scoped=true"
import script from "./SummaryCard.vue?vue&type=script&lang=js"
export * from "./SummaryCard.vue?vue&type=script&lang=js"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&id=038178c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038178c2",
  null
  
)

export default component.exports